import { useQuery } from "@tanstack/react-query";
import { agencyService } from "../../services/agencies";
import { GetFirst } from "../../services/agencies/types";

export const AGENCY_FIRST_QUERY_KEY = "getAgencyFirst";

export const useGetAgencyFirst = (params: GetFirst.Input, enabled = true) => {
  const body = { ...params, active: true, deleted: false };

  const { data, isLoading, refetch } = useQuery({
    queryKey: [AGENCY_FIRST_QUERY_KEY, body],
    enabled,
    queryFn: () => {
      return agencyService.getFirst(body);
    },
  });

  return {
    agency: data?.data,
    isLoading,
    refetch,
  };
};
